export const unitType = {
  TON: "TON",
  CBM: "CBM",
  TEU: "TEU",
};
